"use client";
import Button from "@/components/Cards/Button";
import Newsletter from "@/components/Cards/Newsletter";
import InfoModal from "@/components/Modal";
import Text from "@/components/Text/Text";
import Triangles from "@/components/Triangles";
import { ButtonDark } from "@/stories/Button.stories";
import { NewsletterYellow } from "@/stories/Newsletter.stories";
import { Group, Radio, Textarea } from "@mantine/core";
import "@mantine/dropzone/styles.css";
import { useForm } from "@mantine/form";
import { useState } from "react";
import ErrorModal from "../ErrorModal";
import FileInput from "../Inputs/FileInput";
import { TextInput } from "../Inputs/TextInput";

export default function KundenfeedbackForm({
    sendEmail,
}: {
    sendEmail: (subject: string, data: object) => Promise<void>;
}) {
    const [openModal, setopenModal] = useState(false);
    const [file, setFile] = useState<File | null>(null);
    const [openThankyouModal, setopenThankyouModal] = useState(false);
    const [error, setError] = useState(false);

    const form = useForm({
        initialValues: {
            feedbackType: "",
            opinion: "",
            typeOfPublication: "",
            customerName: "",
            customerSurname: "",
            andere: "",
            email: "",
        },
    });
    return (
        <>
            <InfoModal onClose={() => setopenModal(false)} opened={openModal} size="xl">
                <>
                    <Text
                        hasText={false}
                        hasPretitle={false}
                        hasSubTitle={false}
                        title={"Do you want to give me feedback?"}
                        paddings=""
                    />
                    <form
                        className="space-y-2 my-3"
                        onSubmit={form.onSubmit((values) => {
                            const formData = new FormData();
                            formData.append("file", file as Blob);
                            sendEmail("Feedback", { ...values, file: formData })
                                .then(() => {
                                    setopenModal(false);
                                    setopenThankyouModal(true);
                                })
                                .catch(() => {
                                    <ErrorModal
                                        open={error}
                                        onClose={() => setError(false)}
                                    />;
                                });
                        })}
                    >
                        <Radio.Group
                            label={"How would you like to give me your feedback?"}
                            id="feedbackType"
                            name="feedbackType"
                            {...form.getInputProps("feedbackType")}
                        >
                            <Group mt="xs">
                                <Radio
                                    value="text"
                                    label={"Your opinion"}
                                    className="text-black"
                                />
                                <Radio
                                    value="video"
                                    label="Video"
                                    className="text-black"
                                />
                                <Radio
                                    value="audio"
                                    label="Audio"
                                    className="text-black"
                                />
                            </Group>
                        </Radio.Group>
                        {form.values.feedbackType === "text" && (
                            <Textarea
                                id="opinion"
                                name="opinion"
                                label={"Your feedback"}
                                {...form.getInputProps("opinion")}
                            />
                        )}
                        {form.values.feedbackType === "video" && (
                            <FileInput onFileUpload={setFile} submitFile={console.log} />
                        )}
                        {form.values.feedbackType === "audio" && (
                            <FileInput onFileUpload={setFile} submitFile={console.log} />
                        )}

                        <Radio.Group
                            label={"Type of publication"}
                            id="typeOfPublication"
                            name="typeOfPublication"
                            {...form.getInputProps("typeOfPublication")}
                        >
                            <Group mt="xs">
                                <Radio
                                    id="anonym"
                                    name="anonym"
                                    value="anonym"
                                    label={"Anonymous"}
                                    className="text-black"
                                />
                                <Radio
                                    value="name"
                                    label={"First and last name"}
                                    name="name"
                                    id="name"
                                    className="text-black"
                                />
                                <Radio
                                    id="andereAngaben"
                                    name="andereAngaben"
                                    label={"Other details"}
                                    value="andereAngaben"
                                    className="text-black"
                                />
                            </Group>
                        </Radio.Group>
                        {form.values.typeOfPublication === "name" && (
                            <div>
                                <TextInput
                                    id="customerName"
                                    name="customerName"
                                    label={"Fist name"}
                                    {...form.getInputProps("customerName")}
                                    type="text"
                                />
                                <TextInput
                                    id="customerSurname"
                                    name="customerSurname"
                                    label={"Last name"}
                                    {...form.getInputProps("customerSurname")}
                                    type="text"
                                />
                                <TextInput
                                    id="email"
                                    name="email"
                                    label="Email"
                                    {...form.getInputProps("email")}
                                    type="email"
                                />
                            </div>
                        )}
                        {form.values.typeOfPublication === "andereAngaben" && (
                            <div>
                                <TextInput
                                    id="customerName"
                                    name="customerName"
                                    label={"Fist name"}
                                    {...form.getInputProps("customerName")}
                                    type="text"
                                />
                                <TextInput
                                    id="customerSurname"
                                    name="customerSurname"
                                    label={"Last name"}
                                    {...form.getInputProps("customerSurname")}
                                    type="text"
                                />
                                <TextInput
                                    id="email"
                                    name="email"
                                    label="Email"
                                    {...form.getInputProps("email")}
                                    type="email"
                                />
                                <TextInput
                                    id="andere"
                                    name="andere"
                                    label={"Other details"}
                                    type="text"
                                    {...form.getInputProps("andere")}
                                />
                            </div>
                        )}
                        <div className="flex py-5 justify-end">
                            <Button
                                backgroundColor={ButtonDark.args?.backgroundColor}
                                hasIcon={false}
                                textSize={ButtonDark.args?.textSize}
                                size={ButtonDark.args?.size}
                                paddings={ButtonDark.args?.paddings}
                                textColor={ButtonDark.args?.textColor}
                                text={"SEND NOW"}
                                buttonType="submit"
                            />
                        </div>
                    </form>
                </>
            </InfoModal>
            <InfoModal
                opened={openThankyouModal}
                onClose={() => {
                    setopenThankyouModal(false);
                }}
                size="xl"
                paddings="px-10"
            >
                <>
                    <Text
                        title={"Thank you for your feedback"}
                        hasPretitle={false}
                        hasSubTitle={false}
                        hasText={true}
                        paddings=""
                        paragraphs={[
                            "Thank you for your message. We will get back to you as soon as possible.",
                            "Best regards",
                            "Rico Brunner",
                        ]}
                    />
                    <div className="flex py-5 justify-end">
                        <Button
                            backgroundColor={ButtonDark.args?.backgroundColor}
                            hasIcon={false}
                            textSize={ButtonDark.args?.textSize}
                            size={ButtonDark.args?.size}
                            paddings={ButtonDark.args?.paddings}
                            textColor={ButtonDark.args?.textColor}
                            text="Home"
                            as="a"
                            href={"/"}
                        />
                    </div>
                </>
            </InfoModal>
            <div className="bg-yellow flex justify-center">
                <div className=" w-full  px-3  md:px-10 flex-col justify-center items-center gap-6 inline-flex">
                    <Newsletter
                        backgroundColor={NewsletterYellow.args?.backgroundColor}
                        hasCheckbox={NewsletterYellow.args?.hasCheckbox}
                        hasDescription={NewsletterYellow.args?.hasDescription}
                        hasInput={NewsletterYellow.args?.hasInput}
                        hasSubText={NewsletterYellow.args?.hasSubText}
                        title={
                            "Do you want to provide feedback?"
                        }
                        description={"Please send me a recording, video or text ;)"}
                        buttonText={"SEND FEEDBACK NOW"}
                        onClickButton={() => {
                            setopenModal(true);
                        }}
                        buttonPaddings="px-2 lg:px-10 py-4"
                    />
                </div>
            </div>
            <div className="bg-yellow">
                <Triangles backgroundColor="bg-darkGray" buttomToTop={false} />
            </div>
        </>
    );
}
